import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@roger/ui-components';
import { EpisodeVitalsSummary } from '../vitals';

/**
 * Nested clinical views under the patient-chart Vitals tab.
 *
 * Only Vital Signs ships today. Extra sub-tabs (e.g. discharge functional
 * scores) can be added here later without renaming Christine’s Vitals tab —
 * confirm any top-level rename (Insights / Clinical) with her first.
 */
type VitalsSubTab = 'vital-signs';

const SUB_TABS: Array<{ id: VitalsSubTab; label: string }> = [
  { id: 'vital-signs', label: 'Vital Signs' },
];

type VitalsTabProps = {
  patientId: string;
  episodeId: string | null | undefined;
  episodeStartDate?: string | null;
  episodeEndDate?: string | null;
};

export function VitalsTab({
  patientId,
  episodeId,
  episodeStartDate,
  episodeEndDate,
}: VitalsTabProps) {
  const [subTab, setSubTab] = useState<VitalsSubTab>('vital-signs');
  const showSubTabBar = SUB_TABS.length > 1;

  return (
    <div className='space-y-2'>
      <Tabs
        value={subTab}
        onValueChange={v => setSubTab(v as VitalsSubTab)}
        className='w-full'
      >
        {showSubTabBar && (
          <TabsList>
            {SUB_TABS.map(tab => (
              <TabsTrigger key={tab.id} value={tab.id}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        )}

        <TabsContent
          value='vital-signs'
          className={showSubTabBar ? 'mt-4' : 'mt-0'}
        >
          <EpisodeVitalsSummary
            patientId={patientId}
            episodeId={episodeId}
            episodeStartDate={episodeStartDate}
            episodeEndDate={episodeEndDate}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
